<template class="availableDealerCodeSelector adcs">
  <b-form-group
    :label="labelText"
    label-for="dealerCodeFilter"
  >
    <v-select
      id="dealerCodeFilter"
      :value="selectedAccount"
      label="DisplayWithSubDealers"
      class="filter disableClear adcs____account-selector"
      :options="dealerCodeOptions"
      :select-on-tab="true"
      @input="SelectDealerCode"     
      :filter="FuseSearch"
    />
  </b-form-group>
</template>

<script>
  import { mapGetters } from "vuex"
  import vSelect from "vue-select"
  import $ from "jquery"
  import Fuse from "fuse.js" 

  export default {
    components: {
      vSelect
    },
    props: {
      updateDealerCode: {
        type: String,
        default: ""
      },
      showAllBranchesOption: {
        type: Boolean,
        default: true
      },
      defaultDealercode: {
        type: String,
        default: null
      },
      showLabel: {
        type: Boolean,
        default: true
      }
    },
    data: () => ({
      dealerCodeOptions: [],
      selectedAccount: "",
      initialDealerCodes: Object
    }),
    computed: {
      ...mapGetters(["user", "availableDealerCodes", "getContentItem"]),
      labelText() {
        if (this.showLabel) {
          return this.getContentItem("dealer");
        }
        return null;
      }
    },
    created () {
      this.dealerCodeOptions = []
      if (this.dealerCodeOptions.length > 0) {
        return
      }
      let options = this.availableDealerCodes.slice() // force a copy of array instead of reference
      let allBranches = { value: "All Branches", DisplayWithSubDealers: "All Branches" }
      if(this.showAllBranchesOption){
        options.unshift(allBranches);
      }
      if(this.defaultDealercode !== null){
        this.selectedAccount = this.DealerCodeWithSubDealers(this.defaultDealercode, this.availableDealerCodes);
      }
      else {
        this.selectedAccount = this.DealerCodeWithSubDealers(this.user.DealerCode, this.availableDealerCodes);
      }
      this.dealerCodeOptions = options;
    },
    methods: {
      SelectDealerCode: function (selectedAvailableDealerCode) {
        this.$emit("selectDealerCode", selectedAvailableDealerCode)
      },
      DealerCodeWithSubDealers (dealerCode, availableDealerCodes) {
        if (availableDealerCodes == undefined || availableDealerCodes.length == 0) {
          return dealerCode
        }
        var foundDealerDetails = $.grep(availableDealerCodes, function (availableDealerCode, i) {
          return (availableDealerCode.PrimaryDealerCode == dealerCode)
        })

        if (foundDealerDetails !== undefined && foundDealerDetails.length == 1) {
          this.initialDealerCodes = foundDealerDetails[0];
          this.$emit("initialDealerCodes", this.initialDealerCodes)
          return foundDealerDetails[0].DisplayWithSubDealers
        } else {
          return dealerCode
        }
      },
      FuseSearch(options, search){
        const fuse = new Fuse(options, {
          // keys can be given higher weights to increase their importance (default weight is 1)
          keys:[ 'CompanyName', 'Display', 'DealerCodes'],
          shouldSort: true,
          includeMatches: true,
          // Threshold of 0.0 only matches perfect matches.  
          // Threshold of 1.0 matches anything (maximum fuzziness)
          threshold: 1.0
        })       

        let searchResult = search.length 
          ? fuse.search(search).map(({ item }) => item)
          : fuse.list

        return searchResult;
      }
    },
  }
</script>
<style lang="scss">
  @media (min-width: $screen-md-max){
    .adcs____account-selector ul{
      min-width: 800px !important;
    }
  }

  @media (max-width: $screen-sm-max){
    .adcs____account-selector{
      max-width: 82vw;
      min-width: 50vw;
    }
      
    .adcs____account-selector ul{
      max-width: 82vw;
      min-width: 50vw;
    }
  }
 
</style>
